// FullCalendar uses wall-clock date markers internally. Resolve the real instant
// through its date environment, then change the mutation before the mirror renders.
export function snapAppointmentDrag(mutation, hit, event, resolveMove) {
  if (!event || !resolveMove || !mutation.datesDelta) return;
  const { dateEnv } = hit.context;
  const original = dateEnv.createMarker(event.extendedProps.source.startsAt);
  const requested = dateEnv.toDate(dateEnv.add(original, mutation.datesDelta));
  const move = resolveMove(event, requested);
  if (!move) return; // eventAllow rejects destinations outside available windows.
  const target = dateEnv.createMarker(move.startsAt);
  mutation.datesDelta = { years: 0, months: 0, days: 0, milliseconds: +target - +original };
}
